import { render, staticRenderFns } from "./AccidentIntakeHealthQuestionsForm.vue?vue&type=template&id=ec9d0e08"
import script from "./AccidentIntakeHealthQuestionsForm.vue?vue&type=script&lang=js"
export * from "./AccidentIntakeHealthQuestionsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports